import { useListingCalendarQuery as e } from "./useListingCalendarQuery.mjs";
import { useMemo as t } from "react";
import { AmountFormat as n, formatCurrency as r } from "@maat/currency";
//#region src/listings/useListingAvailability.ts
var i = (i) => {
	let { data: a, fetchNextPage: o, hasNextPage: s, isFetchingNextPage: c } = e(i);
	return {
		blockedRanges: t(() => a?.pages.flatMap((e) => e.blocked_ranges.map((e) => ({
			from: e.from,
			to: e.to
		}))) ?? [], [a]),
		annotations: t(() => a?.pages.flatMap((e) => Object.values(e.pricing).map((t) => ({
			date: t.date,
			label: r(t.adjustedNightlyRate, e.currency, n.Short),
			variant: t.adjustedNightlyRate > e.base_price ? "highlight" : "default"
		}))) ?? [], [a]),
		remainingByDate: t(() => {
			let e = {};
			for (let t of a?.pages ?? []) for (let n of Object.values(t.pricing)) n.remaining !== void 0 && (e[n.date] = n.remaining);
			return e;
		}, [a]),
		fetchNextPage: o,
		hasNextPage: s,
		isFetchingNextPage: c
	};
};
//#endregion
export { i as useListingAvailability };
